import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { objectOf, func, number, shape, oneOfType, string, object, bool } from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import InputField from '#component/form/input';
import { downloadFile } from '#action/download';
import {
  FileInfoCnt,
  FieldsCnt,
  ButtonCnt,
  FileNameField,
  FileDescriptionField
} from './styles';
import { isUndefinedOrNull } from '#helper';

const Document = props => {
  const {
    index,
    file,
    member,
    remove,
    disabled
  } = props;
  const dispatch = useDispatch();
  const { id } = useParams();
  const methods = useFormContext();
  const { control, setValue, getValues } = methods || {};

  const handleDownloadFile = () => {
    dispatch(downloadFile(`shipment/${id}/file/${file.id}`, `${file.name}.${file.extension}`));
  };

  const handleDelete = event => {
    event.stopPropagation();
    remove(index);
    if (isUndefinedOrNull(file.file)) {
      const filesToDelete = getValues?.('filesToDelete') || [];
      setValue?.('filesToDelete', [...filesToDelete, file]);
    }
  };

  return (
    <FileInfoCnt>
      <FieldsCnt>
        <FileNameField>
          <Controller
            name={`${member}.name`}
            control={control}
            render={({ field: controllerField, fieldState }) => (
              <InputField
                {...controllerField}
                meta={fieldState}
                label="File"
                variant="outlined"
                disabled={isUndefinedOrNull(file.file) || disabled}
              />
            )}
          />
        </FileNameField>
        <FileDescriptionField>
          <Controller
            name={`${member}.description`}
            control={control}
            render={({ field: controllerField, fieldState }) => (
              <InputField
                {...controllerField}
                meta={fieldState}
                label="Description"
                placeholder={isUndefinedOrNull(file.file) ? '' : 'Description'}
                variant="outlined"
                disabled={isUndefinedOrNull(file.file) || disabled}
                InputLabelProps={isUndefinedOrNull(file.file) || disabled ? { shrink: true } : {}}
              />
            )}
          />
        </FileDescriptionField>
      </FieldsCnt>
      <ButtonCnt>
        <section>
          <IconButton onClick={handleDownloadFile} disabled={!isUndefinedOrNull(file.file)} aria-label="Download file">
            <Tooltip title="Download file">
              <SaveAltRoundedIcon />
            </Tooltip>
          </IconButton>
        </section>
        <section>
          <IconButton disabled={disabled} onClick={handleDelete} aria-label="Delete file">
            <Tooltip title="Delete file">
              <DeleteIcon />
            </Tooltip>
          </IconButton>
        </section>
      </ButtonCnt>
    </FileInfoCnt>
  );
};

Document.propTypes = {
  array: objectOf(func),
  index: number.isRequired,
  file: shape({
    id: oneOfType([number, string]),
    name: string,
    extension: string,
    description: string,
    // eslint-disable-next-line react/forbid-prop-types
    file: object
  }).isRequired,
  member: string.isRequired,
  remove: func.isRequired,
  disabled: bool
};

export default Document;
